import FilterBy, {
  FilterByOptions,
  FilterBySelectedItems,
  Option,
} from '../../FilterBy';
import AccountDto from '../../../../../shared/models/AccountModel';

export interface AdminFilters extends FilterBySelectedItems {
  role: string[];
  dealAccess: string[];
}

interface FilterAdminProps {
  onFilter: (
    isFiltering: boolean,
    selectedFilters: AdminFilters | FilterBySelectedItems,
  ) => void;
  show: boolean;
  currentAccountData: AccountDto;
}

export function setAdminFilterDefaults(): AdminFilters | FilterBySelectedItems {
  return { role: [], dealAccess: [] };
}

export default function FilterAdmin({
  onFilter,
  show = false,
  currentAccountData: accountData,
}: FilterAdminProps) {
  const options: Option[] = [];
  accountData.deals.map((deal) => {
    options.push({
      label: deal,
      value: deal,
    });
    return deal;
  });

  const filterByItems: FilterByOptions[] = [
    {
      text: 'Role',
      key: 'role',
      options: [
        { label: 'Account Admin', value: 'B2B:ADM' },
        { label: 'Reporter', value: 'B2B:RPT' },
      ],
    },
  ];

  return (
    <div className={show ? 'd-block' : 'd-none'}>
      <FilterBy
        onChange={(selectedItems) => {
          const selected: AdminFilters = {
            role: [],
            dealAccess: [],
            ...selectedItems,
          };
          const filtered =
            selected?.role.length > 0 || selected?.dealAccess.length > 0;
          onFilter(filtered, selected);
        }}
        items={filterByItems}
      />
    </div>
  );
}
